import React from 'react';

import { useGlobalState } from '../hooks/global';

const streamlitContainerStyles = {
  width: '(100% + 20px)',
  height: '95vh',
  margin: '-10px',
  marginBottom: '-200px',
  display: 'flex',
  lexDirection: 'column',
};

const StreamlitWrapper = ({ url }) => {
  const { jwt } = useGlobalState();
  const iframeSrc = jwt ? `${url}?jwks=${jwt}` : undefined;

  return (
    <div style={streamlitContainerStyles}>
      <iframe
        title="Unified Attribution"
        src={iframeSrc}
        style={{ width: '100%', height: '100%', border: 'none', flex: '1 1 auto' }}
      />
    </div>
  );
};

export default StreamlitWrapper;
